import React from 'react';
import DealerLayout from 'components/Layout/Dealer/DealerLayout';
import { LicenseContainer } from 'pages/Shared/LicenseInfo';

export const DealerLicenseInfoComponent = () => {
  return (
    <DealerLayout>
      <div className="dealer-license-info">
        <LicenseContainer />
      </div>
    </DealerLayout>
  );
};
